import { useEffect, useState } from 'react';
import { useNavigate, Link, Outlet, useLocation } from 'react-router-dom';
import axios from 'axios';
import { LogOut, FileText, Users, Mail, BookOpen, Heart } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(null);

  useEffect(() => {
    verifyAuth();
  }, []);

  const verifyAuth = async () => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      navigate('/admin/login');
      return;
    }

    try {
      const response = await axios.get(`${BACKEND_URL}/api/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUser(response.data);
    } catch (error) {
      console.error('Auth error:', error);
      localStorage.removeItem('adminToken');
      navigate('/admin/login');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    navigate('/admin/login');
  };

  const navItems = [
    { path: '/admin/dashboard', label: 'Applications', icon: FileText },
    { path: '/admin/partners', label: 'Partner Inquiries', icon: Users },
    { path: '/admin/contacts', label: 'Contacts', icon: Mail },
    { path: '/admin/donations', label: 'Donations', icon: Heart },
    { path: '/admin/blog', label: 'Blog', icon: BookOpen }
  ];

  if (!user) return null;

  return (
    <div className="min-h-screen bg-black text-white dark" data-testid="admin-layout">
      <div className="flex">
        <aside className="w-64 bg-card border-r border-border min-h-screen" data-testid="admin-sidebar">
          <div className="p-6">
            <h1 className="text-2xl font-unbounded font-black mb-8">AI HOUSE ADMIN</h1>
            <nav className="space-y-2">
              {navItems.map((item) => {
                const Icon = item.icon;
                const isActive = location.pathname === item.path;
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
                    className={`flex items-center gap-3 px-4 py-3 font-manrope transition-colors ${
                      isActive ? 'bg-accent text-white' : 'hover:bg-accent/10'
                    }`}
                  >
                    <Icon size={20} />
                    {item.label}
                  </Link>
                );
              })}
            </nav>
          </div>
          <div className="absolute bottom-0 w-64 p-6 border-t border-border">
            <div className="mb-4">
              <p className="text-sm font-manrope text-gray-400">Logged in as</p>
              <p className="font-manrope font-medium">{user.email}</p>
            </div>
            <button
              onClick={handleLogout}
              data-testid="logout-button"
              className="flex items-center gap-2 text-sm font-manrope text-gray-400 hover:text-white transition-colors"
            >
              <LogOut size={16} />
              Logout
            </button>
          </div>
        </aside>

        <main className="flex-1 p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
};
